import { gql } from 'apollo-boost';

export const getUnreadNotificationCount = gql`
  query notificationLog($orgId: ID!) {
    notificationLog {
      unreadNotificationCount(orgId: $orgId)
    }
  }
`;

export const notificationLogPaged = gql`
  query notificationLog(
    $orgId: ID!
    $limit: Int!
    $offset: Int!
    $includeViewed: Boolean!
  ) {
    notificationLog {
      paged(
        orgId: $orgId
        limit: $limit
        offset: $offset
        includeViewed: $includeViewed
      ) {
        totalCount
        results {
          id
          createdUtc
          link
          orgId
          viewed
          title
          headerMessage
          content
        }
      }
    }
  }
`;
